import React, { useCallback, useMemo, useState, useEffect } from "react"; // Added useMemo
import MapView from "./mapView";
import useTripStore from "@/stores/tripBuilder/useTrip";
import useView from "@/stores/tripBuilder/useView";

// Components
import Accommodation from "./accommodation";
import TripParticipants from "./TripParticipants";
import BudgetWeatherWidget from "./BudgetWeather";
import LocationUpdates from "./LocationUpdates";
import BookingProgress from "./bookingProgress";
import BudgetCategories from "./BudgetCategories";

import { ItineraryItem } from "@/types/trip";

type CategoryKey = "transport" | "accommodation" | "activities";

interface CategoryConfig {
  key: CategoryKey;
  icon: string;
  label: string;
}

type BaseBookingStats = {
  completed: boolean;
  isPending: boolean;
};

type ActivityBookingStats = {
  completed: number;
  total: number;
};

type BookingStats =
  | BaseBookingStats
  | (BaseBookingStats & { count: ActivityBookingStats });

const CATEGORIES: CategoryConfig[] = [
  { key: "transport", icon: "fa-plane", label: "Transport" },
  { key: "accommodation", icon: "fa-bed", label: "Stay" },
  { key: "activities", icon: "fa-ticket", label: "Activities" },
];

const McOverview: React.FC = () => {
  const { tripData, selectedLocation, checkIsAdmin } = useTripStore();
  const { setActiveTab } = useView();
  const isAdmin = useMemo(() => checkIsAdmin(), [checkIsAdmin]);

  const users = tripData?.users || [];

  const mainLocationLodging = selectedLocation?.accommodation.main;

  const switchToAccommodation = useCallback(() => {
    setActiveTab("accommodation");
  }, [setActiveTab]);

  return (
    <div className="flex flex-col w-full gap-2 h-[calc(100dvh-9.5rem)] overflow-hidden">
      {/* Row 1: Accommodation and Updates */}
      <div className="flex flex-row gap-2 h-1/2 2xl:h-[44%] min-h-0">
        <div className="w-[55%] bg-white rounded-xl overflow-hidden">
          <Accommodation
            onSearchClick={switchToAccommodation}
            mainLocationLodging={mainLocationLodging || null}
            selectedLocation={selectedLocation}
          />
        </div>
        <div className="w-[45%] bg-white rounded-xl overflow-hidden">
          <LocationUpdates location={selectedLocation} />
        </div>
      </div>

      {/* Row 2: Trip Info and Map */}
      <div className="flex flex-row gap-2 h-1/2 2xl:h-[53.5%] min-h-0">
        {isAdmin && selectedLocation ? (
          <>
            <div className="w-[35%] bg-neutral-100 rounded-xl p-2 flex flex-col gap-1.5 overflow-hidden">
              <TripParticipants
                users={users}
                locationId={selectedLocation?.id || ""}
              />
              <BookingProgress locationId={selectedLocation?.id || ""} />
              <BudgetWeatherWidget />
            </div>
            <div className="w-[65%] overflow-hidden">
              <MapView />
            </div>
          </>
        ) : (
          <>
            <div className="w-[35%] bg-neutral-100 rounded-xl p-2 flex flex-col gap-1.5 overflow-hidden">
              <BudgetCategories />
            </div>
            <div className="w-[65%] overflow-hidden">
              <MapView />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default McOverview;
